import NextImage, { ImageLoaderProps } from 'next/image';
import get from 'ts-get';

import { CardButton } from '../../../../../../components/Cards/CardButton';
import { getCatchCardEventProperties } from '../../../../../../components/PostsViewer/helpers/getCatchCardEventProperties';
import { useAnalytics } from '../../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { GetCatchesInMapBoundingBox_mapArea_catches_edges_node_post } from '../../../../../../interfaces/graphql';
import { useExplore } from '../../../../context/ExploreContext';
import { EmptyCatchCardImage } from '../../EmptyCatchCardImage/EmptyCatchCardImage';
import { getImgProxyLoader } from '../../../../../../helpers/imageLoaders/imgProxy';

export const CatchesViewList = ({
  catchPosts,
}: {
  catchPosts: GetCatchesInMapBoundingBox_mapArea_catches_edges_node_post[];
}) => {
  const { saveParamsInUrl } = useExplore();
  const { currentPage } = useAnalytics();

  return (
    <div className="bg-lake-fog mt-4 grid grid-cols-2 gap-2 sm:grid-cols-1">
      {catchPosts.map(post => {
        const image = get(post, p => p.images.edges[0].node);
        const imageUrl = image?.url ?? '';
        const imageWidth = image?.width ?? 0;
        const imageHeight = image?.height;

        const imgProxyLoader = ({ src, width, quality }: ImageLoaderProps): string =>
          getImgProxyLoader(src, width, imageWidth, imageHeight, { quality });

        const handleCatchCardClick = (): void => {
          saveParamsInUrl({ postViewerOpen: 'true', currentPostViewerId: post._id });
        };

        return (
          <CardButton
            className="relative aspect-2/3 w-full cursor-pointer rounded-md p-0! sm:aspect-video"
            data-testid={`map-catches-drawer-catch-${post._id}`}
            id={post._id}
            key={post._id}
            eventProperties={getCatchCardEventProperties({
              postId: post._id,
              currentPage,
              source: 'explore-catches-drawer',
            })}
            onClick={handleCatchCardClick}
            ariaLabel="catch in map area"
          >
            {imageUrl ? (
              <NextImage
                alt="catch in map area"
                className="size-full rounded-md object-cover"
                src={imageUrl}
                loader={imgProxyLoader}
                fill
                sizes="(min-width: 1680px) 385px,(min-width: 600px) 25vw, 50vw"
              />
            ) : (
              <EmptyCatchCardImage />
            )}
          </CardButton>
        );
      })}
    </div>
  );
};
